import React from 'react'
import { Box, Stack, Group } from '@mantine/core'
import SlopUploadModal from './SlopUploadModal'
import SlopPostDetailModal from './SlopPostDetailModal'
import AppButton from '../../app/common/ui/AppButton'
import AppText from '../../app/common/ui/AppText'
import type { SlopLibraryFeed } from './hooks/useSlopLibraryFeed'

interface SlopFeedOverlaysProps {
  feed: SlopLibraryFeed
}

/** Upload, detail modal, and delete confirm — shared by library + embed routes. */
export default function SlopFeedOverlays ({ feed }: SlopFeedOverlaysProps) {
  return (
    <>
      <SlopPostDetailModal
        selectedPost={feed.selectedPost}
        setSelectedPost={feed.setSelectedPost}
        isLoggedIn={feed.isLoggedIn}
        isAdmin={feed.isAdmin}
        history={feed.history}
        comments={feed.comments}
        commentsLoading={feed.commentsLoading}
        newComment={feed.newComment}
        setNewComment={feed.setNewComment}
        commentSubmitting={feed.commentSubmitting}
        replyingToId={feed.replyingToId}
        setReplyingToId={feed.setReplyingToId}
        replyText={feed.replyText}
        setReplyText={feed.setReplyText}
        shareCopied={feed.shareCopied}
        requireAuth={feed.requireAuth}
        handleToggleLike={feed.handleToggleLike}
        handleShare={feed.handleShare}
        handleAddComment={feed.handleAddComment}
        handleAddReply={feed.handleAddReply}
        handleDeleteComment={feed.handleDeleteComment}
        setDeleteConfirmId={feed.setDeleteConfirmId}
      />

      {feed.deleteConfirmId !== null && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 400,
            background: 'rgba(0,0,0,0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16
          }}
          onClick={() => feed.setDeleteConfirmId(null)}
        >
          <Stack
            gap="md"
            p="lg"
            onClick={(e) => e.stopPropagation()}
            sx={{
              background: 'var(--gs-surface2)',
              border: '1px solid var(--gs-border)',
              borderRadius: 8,
              maxWidth: 400,
              width: '100%'
            }}
          >
            <AppText>Are you sure you want to delete this post?</AppText>
            <Group position="right">
              <AppButton variant="default" onClick={() => feed.setDeleteConfirmId(null)}>
                Cancel
              </AppButton>
              <AppButton
                color="red"
                loading={feed.deleteLoading}
                onClick={() => feed.deleteConfirmId && void feed.handleDeletePost(feed.deleteConfirmId)}
              >
                Delete
              </AppButton>
            </Group>
          </Stack>
        </Box>
      )}

      <SlopUploadModal
        uploadModalOpen={feed.uploadModalOpen}
        closeUploadModal={feed.closeUploadModal}
        uploadError={feed.uploadError}
        videoFile={feed.videoFile}
        setVideoFile={feed.setVideoFile}
        uploadTitle={feed.uploadTitle}
        setUploadTitle={feed.setUploadTitle}
        uploadDescription={feed.uploadDescription}
        setUploadDescription={feed.setUploadDescription}
        consentGiven={feed.consentGiven}
        setConsentGiven={feed.setConsentGiven}
        firearmModels={feed.firearmModels}
        cartridgeOptions={feed.cartridgeOptions}
        firearmListLoading={feed.firearmListLoading}
        firearmSearch={feed.firearmSearch}
        setFirearmSearch={feed.setFirearmSearch}
        selectedFirearmModelId={feed.selectedFirearmModelId}
        setSelectedFirearmModelId={feed.setSelectedFirearmModelId}
        selectedCartridgeSpecId={feed.selectedCartridgeSpecId}
        setSelectedCartridgeSpecId={feed.setSelectedCartridgeSpecId}
        uploadLoading={feed.uploadLoading}
        uploadProgress={feed.uploadProgress}
        consentText={feed.consentText}
        consentLoading={feed.consentLoading}
        handleUpload={feed.handleUpload}
      />
    </>
  )
}
